import { formatDuration } from "../../../../app/dateHelpers";
import { Icon, IconDefinitions, LiveBadge, TitlelessCard } from "../../../../components";

interface LiveViewHeaderProps {
  filePathFromQuery: string | null;
  uploadSessionId: string | null;
  isLive: boolean;
  isSessionCompleted: boolean;
  sessionElapsed: number;
}
export function LiveViewHeader({
  filePathFromQuery,
  uploadSessionId,
  isLive,
  isSessionCompleted,
  sessionElapsed,
}: LiveViewHeaderProps) {
  return (
    <TitlelessCard>
      <div className="d-flex align-items-center justify-content-between">
        <div className="d-flex align-items-baseline gap-2">
          <Icon iconName={IconDefinitions.chartLine} className="text-primary" />
          <span className="fw-semibold fs-5">Live View</span>
          <span className="badge bg-warning text-dark" style={{ fontSize: "0.7rem" }}>
            <Icon iconName={IconDefinitions.maintenance} className="me-1" />Under Construction &mdash; Representation Only
          </span>
        </div>
        <div className="d-flex align-items-center gap-2 flex-shrink-0">
          {isLive && (
            <small className="text-muted" style={{ fontSize: "0.8rem" }}>
              <Icon iconName={IconDefinitions.clock} className="me-1" />
              {formatDuration(sessionElapsed)}
            </small>
          )}
          {isSessionCompleted ? (
            <span className="badge bg-secondary">Session Ended</span>
          ) : isLive ? (
            <LiveBadge />
          ) : (
            <small className="text-muted">No active session</small>
          )}
        </div>
      </div>

      {filePathFromQuery && isLive && (
        <div className="d-flex flex-wrap align-items-center gap-1 mt-2 mt-md-1" style={{ minWidth: 0 }}>
          <code className="text-muted text-truncate" style={{ fontSize: "0.75rem" }}>
            {filePathFromQuery}
          </code>
          {uploadSessionId && (
            <>
              <span className="text-muted" style={{ fontSize: "0.8rem" }}>|</span>
              <code className="text-muted text-truncate" style={{ fontSize: "0.75rem" }}>
                {uploadSessionId}
              </code>
            </>
          )}
        </div>
      )}
    </TitlelessCard>
  );
}